import Axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";
import { toVault77ApiError } from "../../core/apiError";
import { AUDIT_LOG_ENDPOINT } from "./constants";
import type { DataAccessAudit, DataAccessAuditFilters } from "../types";

/**
 * Fetch Vault77 data-access audit records (read-only).
 * GET api/vault77/auditLog
 */
export async function getAuditLog(
    filters?: DataAccessAuditFilters
): Promise<DataAccessAudit[]> {
    try {
        let url = AUDIT_LOG_ENDPOINT;
        if (filters) {
            const params = new URLSearchParams();
            if (filters.employeeId != null) params.append("employeeId", String(filters.employeeId));
            if (filters.startDate != null) params.append("startDate", filters.startDate);
            if (filters.endDate != null) params.append("endDate", filters.endDate);
            const query = params.toString();
            if (query) url = `${url}?${query}`;
        }
        const response = await Axios.get<DataAccessAudit[]>(url, AxiosConfig.configValue("min"));
        return response.data;
    } catch (error) {
        console.error("getAuditLog/api ~ error:", error);
        throw toVault77ApiError(error, "Unable to fetch the audit log.");
    }
}
